import CancelIcon from 'assets/images/icons/CancelIcon.svg?react';
import React, { useMemo } from 'react';
import { Control, useWatch } from 'react-hook-form';
import { InvoiceRowCorrectionForm } from 'types/invoices.ts';
import { t } from 'utils/getTranslations';
import { ItemActionButton, ItemActionGroup } from '../../components/ItemActionButton';

interface Props {
    handleCorrect: () => void;
    control: Control<InvoiceRowCorrectionForm>;
}

const InvoiceRowActions: React.FC<Props> = (props) => {
    const { handleCorrect, control } = props;

    const rows = useWatch({ control, name: 'rows' });
    const areActionsDisabled = useMemo(() => !rows?.some((row) => row.selected), [rows]);

    return (
        <ItemActionGroup>
            <ItemActionButton
                tooltip={t('invoices.tooltips.remove-via-correction')}
                disabled={areActionsDisabled}
                onClick={handleCorrect}
            >
                <CancelIcon className="size-[18px]" />
            </ItemActionButton>
        </ItemActionGroup>
    );
};

export default InvoiceRowActions;
